/**
 * INGÅNGEN. Läser stilarna i rätt ordning och monterar appen.
 *
 * ORDNINGEN ÄR INTE FRI: typsnitt.css står först, för den bär @font-face och
 * ska vara känd innan något ritas. Sedan tokens.css, för bas.css och
 * komponenter.css läser dess variabler. Fyra filer och inget byggsteg för
 * CSS — appen har ett designsystem, inte en stilmotor.
 *
 * StrictMode är PÅ. Den kör effekter två gånger i utvecklingsläge, och det är
 * nyttigt: det avslöjade redan (när inloggningen var en länk) att en token
 * bara fick växlas in en gång. En app som bara fungerar utan StrictMode har
 * en bugg som ännu inte visat sig.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './design/typsnitt.css';
import './design/tokens.css';
import './design/bas.css';
import './design/komponenter.css';
import { App } from './App';

const rot = document.getElementById('rot');
if (rot === null) throw new Error('index.html saknar <div id="rot">');

createRoot(rot).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
